import Home from './../views/Home'
import FormHome from './../../default/views/form/Home'

import {middlewareUserHome} from '@/companies/default/router/Middlewares'

var routes = {
    list: [
        { path: '/', component: Home, name: 'home', beforeEnter: middlewareUserHome},
        { path: '/form', component: FormHome, name: 'form.home', meta: {onlyForm: true}},
    ],
    ban: []
}

export default routes



// WEBPACK FOOTER //
// ./src/companies/marketmaker/router/routes.js